import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';

const hasAuthResponse = (value) => {
  const params = new URLSearchParams(value.slice(1));
  return params.has('state') && (params.has('code') || params.has('error') || params.has('ear_jwe'));
};

if (hasAuthResponse(window.location.hash) || hasAuthResponse(window.location.search)) {
  broadcastResponseToMainFrame().catch((error) => {
    console.error('Authentication redirect bridge failed', error);
    document.getElementById('app').textContent = 'Sign-in could not be completed. Please reload and try again.';
  });
} else {
  import('./app-bootstrap').catch((error) => {
    console.error('Application startup failed', error);
    document.getElementById('app').textContent = 'The application could not be loaded. Please reload and try again.';
  });
}
